/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SheetSelectorInput } from '../../models/sheet-selector-input.model';

@Component({
    selector: 'app-sheet-selector',
    templateUrl: './sheet-selector.component.html',
    styleUrls: ['./sheet-selector.component.scss'],
    standalone: false
})
/**
 * Reusable dialog to select sheets from an Excel workbook after a user uploads an Excel file.
 */
export class SheetSelectorComponent {

  // Sheets user can select from
  sheets: string[];
  // boolean controlling whether multiple sheets can be selected
  isMultiSelect: boolean = true;

  // Sheet names to be passed out
  selectedSheets: string[];

  constructor(private readonly dialogRef: MatDialogRef<SheetSelectorComponent>,
              @Inject(MAT_DIALOG_DATA) private data: SheetSelectorInput) {
    this.sheets = data.sheets;
    if (this.data.isMultiSelect !== undefined) {
      this.isMultiSelect = data.isMultiSelect;
    }
  }

  /**
   * If a user cancels the selection, return no sheets.
   */
  onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * On confirmation, return the selected sheets as a string[].
   */
  onConfirm(): void {
    this.dialogRef.close(this.selectedSheets);
  }

}
